import React, { useEffect, useState } from 'react'
import "./CSS/User_Management.css"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { connect } from 'react-redux'
import Store from '../Store/Store'
import { add_group_item, add_user_item, set_user_item } from '../Action/Action'

const User_Management = (props) => {

    const history = useHistory()

    const [add_area_active, Set_add_area_active] = useState(false)
    const [add_area_active2, Set_add_area_active2] = useState(false)

    const [groupList, Set_groupList] = useState([])
    const [userList, Set_userList] = useState([])

    const [inital_company_select_control, Set_inital_company_select_control] = useState(true);


    const [createUserCID, Set_createUserCID] = useState("")
    const [createUserCID2, Set_createUserCID2] = useState("")
    const [createUserCID3, Set_createUserCID3] = useState("")



    useEffect(() => {
        console.log(createUserCID, createUserCID2);
        if (inital_company_select_control) {
            if (createUserCID2 !== "") {
                let data = props.user_list;
                let newData = [];
                data.forEach(x => {
                    if (x.companyId === createUserCID) {
                        newData.push(x)
                    }
                })

                Set_userList(newData);
                console.log(createUserCID2);
                Set_inital_company_select_control(false)

            }
        } else {
            if (createUserCID !== "") {
                let data = props.user_list;
                let newData = [];
                data.forEach(x => {
                    if (x.companyId === createUserCID) {
                        newData.push(x)
                    }
                })

                Set_userList(newData);
            }
        }


    }, [createUserCID, createUserCID2])


    useEffect(() => {
        Set_groupList(props.group_list)
    }, [props.group_list])

    useEffect(() => {
        Set_userList(props.user_list)
    }, [props.user_list])

    const [add_users, Set_add_users] = useState([]);

    //yetkilendirme
    const [user_yazma_control, Set_user_yazma_control] = useState(false);


    useEffect(() => {
        if (props.yetkilendirme && props.uid !== "") {
            let data = props.yetkilendirme;
            let newObj = data[props.uid];
            if (newObj !== undefined) {
                if (newObj["Kullanıcı Paneli"]["Y"] === "t") {

                    Set_user_yazma_control(true)
                } else {
                    Set_user_yazma_control(false)
                }

            }
        }
    }, [props.yetkilendirme])



    const addGroupFunction = async () => {
        try {
            if (group_name !== "" && group_desc !== "") {

                const request = await fetch("http://localhost:5285/api/person/AddGroup", {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        groupName: group_name,
                        description_: group_desc,
                        companyId: props.com_id,
                        users: "",
                        yetkilendirme: null
                    })
                })

                const response = await request.json();

                console.log(response);

                let new_obj = { groupName: group_name, description_: group_desc, users: [] }
                Store.dispatch(add_group_item(new_obj))

            }

        } catch (err) {
            console.log(err)
        } finally {
            Set_group_desc("")
            Set_group_name("")
            Set_add_area_active(false)
            document.querySelectorAll(".user_add_item_active").forEach(i => {
                i.classList.toggle("user_add_item_active")
            })
        }

    }

    const addUserFunction = async () => {
        try {
            if (user_name !== "" && user_email !== "" && user_pwd !== "" && createUserCID !== "") {

                let new_obj = { userName: user_name, email: user_email, pwd: user_pwd }
                try {
                    const req_ = await fetch(`https://app-rmmsapi.azurewebsites.net/api/person/CreateUser`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            "accept": "application/json"
                        },
                        body: JSON.stringify({
                            "username": user_name,
                            "password": user_pwd,
                            "email": user_email,
                            "companyId": createUserCID3 !== "" ? createUserCID3 : createUserCID,
                            "yetkilendirme": ""
                        }) // Convert the body object to a JSON string
                    })
                    const response = await req_.json()
                    console.log(response);
                    if (response === true) {
                        Store.dispatch(add_user_item(new_obj))
                    }
                } catch (err) {
                    console.log(err);
                } finally {
                    try {
                        const req__ = await fetch(
                            "https://app-rmmsapi.azurewebsites.net/api/person/GetUserList",
                            {
                                headers: {
                                    Accept: "applicaiton/json",
                                    "Content-Type": "application/json",
                                },
                                method: "POST",
                                body: JSON.stringify({
                                    companyId: String("1"),
                                }),
                            }
                        );

                        const response__ = await req__.json();


                        if (req__.status === 200 && response__.length > 0) {
                            response__.forEach(a => {
                                if (a.companyId === createUserCID2) {
                                    Store.dispatch(set_user_item(response__));

                                }
                            })
                        }
                    } catch (err) {
                        console.warn(err);
                    }
                }
            }

        } catch (err) {
            console.log(err)
        } finally {
            Set_user_pwd("")
            Set_user_name("")
            Set_user_email("")
            Set_add_area_active2(false)

        }

    }


    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState('Şirket Seçin');

    useEffect(() => { Set_createUserCID(props.com_id) }, [props.com_id])

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (props.com_id !== "1" && createUserCID2 !== "") {
            console.log(props.com_id);
            Set_inital_company_select_control(false)
        }
    }, [props.com_id])

    const handleItemClick = (event) => {
        let id_ = event.target.id;
        console.log(id_);
        if (id_ && id_ !== undefined && id_ !== null) {
            Set_createUserCID(id_)
            Set_createUserCID2(id_)

        }

        setSelectedItem(event.target.textContent);
        setIsOpen(false);
    };

    const [isOpen2, setIsOpen2] = useState(false);
    const [selectedItem2, setSelectedItem2] = useState('Şirket Seçin');

    // Combined click outside handler for both dropdowns - prevents duplicate listeners
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdownx')) {
                setIsOpen(false);
            }
            if (!event.target.closest('.dropdownxx')) {
                setIsOpen2(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };

    const handleItemClick2 = (event) => {
        let id_ = event.target.id;
        console.log(id_);
        if (id_ && id_ !== undefined && id_ !== null) {
            Set_createUserCID3(id_)
        }

        setSelectedItem2(event.target.textContent);
        setIsOpen2(false);
    };

    const [group_name, Set_group_name] = useState("")
    const [group_desc, Set_group_desc] = useState("")

    const onChangegname = (e) => {
        Set_group_name(e.target.value)
    }
    const onChangegdesc = (e) => {
        Set_group_desc(e.target.value)
    }

    const [see_group_detail, Set_see_group_detail] = useState(false)
    const [group_detail, Set_group_detail] = useState({})



    const [user_name, Set_user_name] = useState("")
    const [user_email, Set_user_email] = useState("")
    const [user_pwd, Set_user_pwd] = useState("")

    const [kullancı_ekle_active, Set_kullanıcı_ekle_active] = useState(false)
    const [selected_groups, Set_selected_groups] = useState([])
    const [selected_users, Set_selected_users] = useState([])


    const onChangeuname = (e) => {
        Set_user_name(e.target.value)
    }
    const onChangeupwd = (e) => {
        Set_user_pwd(e.target.value)
    }
    const onChangeuemail = (e) => {
        Set_user_email(e.target.value)
    }


    const [see_user_detail, Set_see_user_detail] = useState(false)
    const [user_detail, Set_user_detail] = useState({})

    const [b_added_users, Set_b_added_users] = useState([])

    const [group_detail_users, Set_group_detail_users] = useState([])

    useEffect(() => {
        if (JSON.stringify(group_detail) !== "{}") {


            let data = []
            let newdata = group_detail.users;
            props.user_list.forEach(x => {
                newdata.forEach(a => {
                    console.log(a, x);
                    if (x.userId === a) {
                        data.push(x)
                    }

                })
            })
            console.log(data);
            Set_group_detail_users(data)
        }

    }, [group_detail])


    useEffect(() => {
        console.log(selected_groups);
        if (selected_groups.length < 1) {
            Set_kullanıcı_ekle_active(false)
        } else {
            groupList.forEach(x => {
                console.log(x);
                if (x.groupId === selected_groups[0] && x.users !== "") {
                    var newdata = []
                    JSON.parse(x.users).forEach(a => {
                        newdata.push(a)
                        console.log(newdata);
                        Set_b_added_users(newdata)
                    })
                }
            })
        }
    }, [selected_groups])

    const AddUsersToGroups = async () => {

        let goToAPIlist;
        let newdata = b_added_users;

        selected_users.forEach(a => {
            if (b_added_users.indexOf(a) < 0) {
                newdata.push(a)
            }
        })

        goToAPIlist = JSON.stringify(newdata)
        selected_groups.forEach(async (a, index) => {
            try {
                const request_ = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/AdduToGroups", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify({
                        groupId: a,
                        users: goToAPIlist
                    })
                })

                const response = await request_.json();

                console.log(response);
            } catch (err) {
                console.log(err);
            } finally {
                window.location.reload()
            }

        })
    }

    const deleteUserFunction = async (uId) => {
        try {
            const request_ = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/DeleteUser", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    userId: uId
                })
            })

            const response = await request_.json();
            if (response) {
                console.log("true");
            }
        } catch (err) {
            console.log(err);
        } finally {
            try {
                const req__ = await fetch(
                    "https://app-rmmsapi.azurewebsites.net/api/person/GetUserList",
                    {
                        headers: {
                            Accept: "applicaiton/json",
                            "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                            companyId:String(props.temp_com_id) ,
                        }),
                    }
                );

                const response__ = await req__.json();


                if (req__.status === 200 && response__.length > 0) {
                    Store.dispatch(set_user_item(response__));
                }
            } catch (err) {
                console.warn(err);
            }
        }
    }


    useEffect(() => { Set_createUserCID(props.com_id) }, [props.com_id])





    return (
        <>
            {!inital_company_select_control && <seciton className="section_user_management">
                <div style={{
                    display: "flex", alignItems: "center", justifyContent: "left", position: "relative",
                    left: "22%", top: "-12px"
                }} className="top">

                    {props.com_id === "1" && <div style={{ width: "10%" }} className="dropdownx">
                        <button style={{ maxWidth: "20%", borderColor: "rgb(237,188,69)", fontWeight: "600" }} className="dropdownx-button" onClick={toggleDropdown}>
                            {selectedItem}
                        </button>
                        {isOpen && (
                            <div style={{ maxWidth: "20%" }} className="dropdownx-content">
                                {props.companies_list && props.companies_list.length>0&&props.companies_list.map((item,index)=>{
                                return <span id={item.companyID} key={item.companyID} data-value={item.companyID} onClick={handleItemClick}>{item.companyName}</span>
                            })}
                                
                            </div>
                        )}
                    </div>}
                    {user_yazma_control && <button style={{ pointerEvents: !user_yazma_control ? "none" : "all", marginBottom: "-3.5%", marginLeft: "-3.5%" }} disabled={!user_yazma_control} onClick={() => {
                        Set_add_area_active2(true)
                    }} className='add_group_btn'>
                        Kullanıcı Ekle
                    </button>}
                    {user_yazma_control && <button style={{ pointerEvents: !user_yazma_control ? "none" : "all", marginBottom: "-3.5%", marginLeft: "3.5%" }} disabled={!user_yazma_control} onClick={() => {
                        Set_inital_company_select_control(true)
                    }} className='add_group_btn'>
                        Şirket Seç
                    </button>}
                </div>


                <div className="bottom">
                    {/* <div className="left">

                    {see_group_detail &&
                        <div className="add_group_area">
                            <i onClick={() => {
                                Set_add_area_active(false)
                                Set_see_group_detail(false)
                                Set_group_detail({})
                                Set_group_detail_users([])
                            }} style={{ position: "relative", left: "48%", color: "brown", scale: "1.3", cursor: "pointer" }} className="fa fa-arrow-left"></i>
                            <div className='displayflexdiv'>
                                <div className="lefcx">
                                    <label htmlFor="name">Grup İsmi</label>
                                    <input value={group_detail.name} disabled type="text" placeholder='Grup Adı' className="add_group_name_inp" />

                                    <label htmlFor="description">Grup Açıklaması</label>
                                    <textarea disabled value={group_detail.desc} id="group_desc_add"></textarea>


                                </div>
                                <div className="rightcx">
                                    <div className="users_list">
                                        <h2>Kullanıcılar</h2>
                                        {group_detail_users.length > 0 ? group_detail_users.map((item, index) => {

                                            return <span style={{ display: "flex", alignItems: "center" }} className='user_item_add_view' id={item.userId}>                                     <i style={{ position: "relative", color: "rgb(80,80,80)", padding: "6px", right: "1%", width: "8px", height: "8px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }} className="fa fa-user"></i>
                                                <p style={{ fontSize: "0.85em" }}>{item.userName}</p>  <p className='group_detail_view_user-email'>{item.email}</p></span>
                                        }) : <p style={{ position: "relative" }} className='empty_info_kullanıcı2'>Bu gruba ait hiç kullanıcı bulunamadı</p>}

                                    </div>

                                </div>
                            </div>

                        </div>}

                    {!add_area_active && !see_group_detail && <div className="group_list">

                        <h2>Gruplar</h2>
                        <ul className='group_ul_list'>
                            {groupList.length > 0 ? groupList.map((item, index) => {
                                console.log(item);
                                return <li className='unselected-li' id={"g" + item.groupId} onClick={(e) => {
                                    if (e.target.classList[0] !== "view_details_btn" && user_yazma_control) {
                                        let div_ = document.querySelector(`#g${item.groupId}`).classList
                                        if (!div_.contains("unselected-li-active")) {
                                            let data_ = [];
                                            data_.push(item.groupId)
                                            console.log(data_);
                                            Set_selected_groups(data_)
                                            div_.toggle("unselected-li-active");
                                            Set_kullanıcı_ekle_active(true)


                                        } else {
                                            div_.toggle("unselected-li-active");

                                            Set_selected_groups([])

                                        }

                                        console.log(e.target.classList[0], selected_groups);

                                    }

                                }}><div style={{ width: "60%" }}><i style={{ marginRight: "4%" }} class="fa-solid fa-user-group"></i> {item.groupName}</div> <p className='view_details_btn' onClick={() => {
                                    Set_see_group_detail(true)
                                    Set_group_detail({ name: item.groupName, desc: item.description_, users: item.users === null ? []: (item.users===""? [] : JSON.parse(item.users)) })
                                }} style={{ fontWeight: "700", color: "rgba(237,188,69,0.8)", cursor: "pointer" }}>Detayları Gör <i className="fa fa-arrow-right"></i></p></li>
                            }) : <p style={{ position: "relative", transform: "translate(55%,400%)" }} className='empty_info_kullanıcı'>Kayıtlı Hiç Grup Yok</p>}
                        </ul>

                    </div>}
                    {add_area_active && <div className="add_group_area">
                        <i onClick={() => {
                            Set_add_area_active(false)
                        }} style={{ position: "relative", left: "48%", color: "brown", scale: "1.3", cursor: "pointer" }} className="fa fa-times"></i>
                        <div className='displayflexdiv'>
                            <div style={{ width: "100%" }} className="lefcx">
                                <label htmlFor="name">Grup İsmi</label>
                                <input value={group_name} onChange={onChangegname} type="text" placeholder='Grup Adı' className="add_group_name_inp" />

                                <label htmlFor="description">Grup Açıklaması</label>
                                <textarea value={group_desc} onChange={onChangegdesc} id="group_desc_add"></textarea>


                            </div>

                        </div>
                        <button onClick={addGroupFunction} className='kaydet_group_btn'>Kaydet</button>


                    </div>}
                </div> */}
                    <div className="right">
                        {see_user_detail && !add_area_active2 && <div className="add_group_area">
                            <i onClick={() => {
                                Set_add_area_active2(false)
                                Set_see_user_detail(false)
                                Set_user_detail({})
                            }} style={{ position: "relative", left: "48%", color: "brown", scale: "1.3", cursor: "pointer" }} className="fa fa-arrow-left"></i>
                            <div className='displayflexdiv'>
                                <div style={{ width: "100%" }} className="lefcx">
                                    <label htmlFor="name">Kullanıcı İsmi-Soyismi</label>

                                    <input value={user_detail.name} type="text" className="add_user_name_inp" />
                                    <label htmlFor="email">Email</label>
                                    <input value={user_detail.email} type="email" className="add_user_email_inp" />

                                    <div style={{ marginTop: "12%" }} className="uuid_part_view_u_detail"><span style={{ color: "rgb(80,80,80)" }}>User ID:</span> {user_detail.user_id}</div>


                                </div>

                            </div>


                        </div>}
                        {!add_area_active2 && !see_user_detail && !kullancı_ekle_active && <div className="group_list">

                            <h2>Kullanıcılar</h2>
                            <ul className='group_ul_list'>
                                {userList.length > 0 ? userList.map((item, index) => {
                                    if (item.companyId === createUserCID) {
                                        return <span className='user_item_add' id={item.id}><div style={{ display: "flex", alignItems: "center", width: "90%", position: "relative", left: "-3%" }}>
                                            <i style={{ position: "relative", backgroundColor: "rgb(237,188,69)", color: "rgb(80,80,80)", padding: "6px", right: "5%", width: "20px", height: "20px", borderRadius: "20px", display: "flex", alignItems: "center", justifyContent: "center" }} className="fa fa-user">
                                            </i>{item.userName} / <p className="user_email_view">{item.email}</p></div> <p onClick={(e) => {
                                                e.preventDefault();
                                                let confirm_ = window.confirm(`${item.email} adlı kullanıcıyı silmek istediğinize emin misiniz?`);
                                                if (confirm_) {
                                                    deleteUserFunction(item.userId)
                                                } else {
                                                    return 0
                                                }
                                            }} style={{ position: "relative", right: "-6%", color: "crimson", cursor: "pointer", fontWeight: "600" }} className='user_see_details sil'>


                                                Sil
                                            </p> <p onClick={() => {
                                                Set_see_user_detail(true)
                                                Set_user_detail({ name: item.userName, pwd: item.pwd, email: item.email, user_id: item.userId })
                                            }} className='user_see_details'>Detaylar <i className="fa fa-arrow-right"></i></p></span>
                                    }

                                }) : <p style={{ position: "relative", transform: "translate(50%,400%)" }} className='empty_info_kullanıcı'>Kayıtlı Hiç Kullanıcı Yok</p>}
                            </ul>

                        </div>}
                        {add_area_active2 && <div className="add_group_area">
                            <i onClick={() => {
                                Set_add_area_active2(false)
                            }} style={{ position: "relative", left: "48%", color: "brown", scale: "1.3", cursor: "pointer" }} className="fa fa-times"></i>
                            <div className='displayflexdiv'>
                                <div style={{ width: "100%" }} className="lefcx">
                                    <label htmlFor="name">Kullanıcı İsmi-Soyismi</label>

                                    <input onChange={onChangeuname} value={user_name} type="text" className="add_user_name_inp" />
                                    <label htmlFor="email">Email</label>
                                    <input onChange={onChangeuemail} value={user_email} type="email" className="add_user_email_inp" />

                                    <label htmlFor="desc">Parola</label>
                                    <input type='password' onChange={onChangeupwd} value={user_pwd} className="add_user_name_inp" />
                                    {props.com_id === "1" && <div className="dropdownx dropdownxx">
                                        <button style={{ borderColor: "rgb(237,188,69)" }} className="dropdownx-button" onClick={toggleDropdown2}>
                                            {selectedItem2}
                                        </button>
                                        {isOpen2 && (
                                            <div className="dropdownx-content">
                                                <span id="1" key="1" data-value="1" onClick={handleItemClick2}>RMMS</span>
                                                <span id="2" key="2" data-value="2" onClick={handleItemClick2}>Akra Hotels</span>
                                                <span id="3" key="3" data-value="3" onClick={handleItemClick2}>Crowne Plaza</span>
                                            </div>
                                        )}
                                    </div>}

                                </div>

                            </div>
                            <button onClick={addUserFunction} className='kaydet_group_btn'>Kaydet</button>




                        </div>}
                        {kullancı_ekle_active && userList.length > 0 && <div className="group_list">

                            <h2 style={{ fontSize: "0.95em" }}>Seçili Gruba Kullanıcı Ekle</h2>
                            <ul className='group_ul_list'>
                                {userList.length > 0 ? userList.map((item, index) => {
                                    return <span onClick={(e) => {

                                        let div_ = document.querySelector(`#g${item.userId}`).classList
                                        if (!div_.contains("selected_user")) {
                                            Set_selected_users(PrevArray => [...PrevArray, item.userId])
                                            div_.toggle("selected_user");


                                        } else {
                                            div_.toggle("selected_user");
                                            let datas = selected_users;
                                            let newdata = datas.filter(i => {
                                                return item.userId !== i
                                            })
                                            Set_selected_users(newdata)

                                        }

                                    }} className={b_added_users.includes(item.userId) ? "user_item_add selected_user" : 'user_item_add'} id={"g" + item.userId}><div style={{ display: "flex", alignItems: "center", width: "90%", position: "relative", left: "-3%" }}>
                                            <i style={{ position: "relative", color: "rgb(80,80,80)", padding: "6px", right: "5%", width: "20px", height: "20px", borderRadius: "20px", display: "flex", alignItems: "center", justifyContent: "center" }} className="fa fa-circle">
                                            </i>{item.userName} / <p className="user_email_view">{item.email}</p></div></span>
                                }) : <p style={{ position: "relative", transform: "translate(50%,400%)" }} className='empty_info_kullanıcı'>Kayıtlı Hiç Kullanıcı Yok</p>}
                            </ul>

                            <button style={{ position: "relative", left: "25%", marginTop: "-1%" }} onClick={AddUsersToGroups} className='kaydet_group_btn'>Kaydet</button>


                        </div>}
                    </div>
                </div>

            </seciton>}

            {
                inital_company_select_control && <section className='section_user_management xf_user_section'>

                    <div style={{ left: "0%", top: "15%" }} className="dropdownx">
                        <button style={{ maxWidth: "100%", fontWeight: "700", fontSize: "larger", borderColor: "rgb(237,188,69)" }} className="dropdownx-button" onClick={toggleDropdown}>
                            {selectedItem}
                        </button>
                        {isOpen && (
                            <div style={{ maxWidth: "130%" }} className="dropdownx-content">
                                {props.companies_list && props.companies_list.length>0&&props.companies_list.map((item,index)=>{
                                return <span id={item.companyID} key={item.companyID} data-value={item.companyID} onClick={handleItemClick}>{item.companyName}</span>
                            })}
                               
                            </div>
                        )}
                    </div>
                </section>
            }
        </>
    )
}

const MapStateToProps = (state) => {
    return {
        group_list: state.project_reducer.groups_list,
        user_list: state.project_reducer.users_list,
        user_id: state.project_reducer.temp_id,
        com_id: state.project_reducer.company_id,
        yetkilendirme: state.project_reducer.yetkilendirme_state,
        group_id: state.project_reducer.group_id,
        uid: state.auth_reducer.user_id,
        companies: state.project_reducer.companies_list,
        temp_com_id: state.project_reducer.temp_com_id,
        companies_list:state.project_reducer.companies_list


    }
}

export default connect(MapStateToProps)(User_Management)